// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"336":"a915d3012effb4c9","533":"e37bf52669b2e018","818":"2745d12caa466976"}[chunkId] + ".js";
};